















import { ActorTypes } from '@/data/models/actor.model';
import { Component, Vue } from 'vue-property-decorator';
import Attori from '../attori/Attori.vue';
import SelectAttore from '../attori/selectAttore/SelectAttore.vue';

@Component({
	components: {
		Attori,
		SelectAttore
	}
})
export default class DottoriList extends Vue{

	entity: string
	isComponentModalActive = false;
	redirectOnNew: string;

	constructor() {
		super();
		this.entity = ActorTypes.DOCTOR;
		this.redirectOnNew = '/attori/*/edit?tab=4';
	}

	onNewClicked() {
		this.isComponentModalActive = true;
	}

}
